"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// load font via webpack asset/resource
// require("src/tokens/index.css");

class Link extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.a = this.root.querySelector("a");
        // this.href = this.getAttribute("href");
        // if (this.href) {
        //     this.button = document.createElement("a");
        //     this.button.setAttribute("href", this.href);
        //     this.button.setAttribute("rel", "noopener");
        //     this.button.setAttribute("target", "_blank");
        // } else {
        //     this.button = document.createElement("button");
        // }
        //
        // // arrow
        // this.iconName = this.gettAttribute("icon");
        // // this.button = this.root.appendChild(this.button);
        // //
        // if (this.innerHTML) {
        //     this.a.innerHTML = this.innerHTML;
        //     if (this.iconName) {
        //         const icon = document.createElement("div");
        //         icon.className = this.iconName;
        //         this.a.appendChild(icon);
        //     }
        //
        // }
        // if (this.hasAttribute("href")) {
        //     this.a.setAttribute("href", this.getAttribute("href"));
        //     this.removeAttribute("href");
        // }
        // this.innerHTML = "";

    }

    get href() {
        return this.a.getAttribute("href");
    }
    set href(href) {
        this.a.setAttribute("href", href);
    }

    connectedCallback() {
        // arrow
        this.iconName = this.getAttribute("icon");
        // this.button = this.root.appendChild(this.button);
        //
        if (this.innerHTML) {
            this.a.innerHTML = this.innerHTML;
            if (this.iconName) {
                const icon = document.createElement("div");
                icon.className = this.iconName;
                this.a.appendChild(icon);
            }

        }
        if (this.hasAttribute("href")) {
            this.a.setAttribute("href", this.getAttribute("href"));
            this.removeAttribute("href");
        }
        if (this.hasAttribute("external")) {
            this.a.setAttribute("target", "_blank");
        }
        this.innerHTML = "";
    }




}

window.customElements.define("swiftref-link", Link);

module.exports = Link;
